module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAACgAAAAAYsJrPAAAAk0lEQVQYGYWQMQ4CIRBFncEjWSLZS9mYrJXZxksZltIrAc4jbLFkjRSQP//NB0ZOfaWUrjnnm4hcKNVaP865l/d+RQtbjPFux9PMpqmxrKnYMYcQFiGplPI2SJs7bMCqOp25zrxDiB4CYHR70xC0kzA/k3akCeV3Y3HUMMoI+u9Gv2k8GGVOJh5HcK/Njdli/g38CxEdRo33LZilAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/椭圆形备份 14.png
// module id = Ys0u
// module chunks = 2